export enum UserRole {
    MceViewer = "mpi.mce.viewer",
    MceOperator = "mpi.mce.operator",
    MceDeveloper = "mpi.mce.developer",
}
